import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const footerLinks = [
  { label: 'API Docs', to: '/api-docs' },
  { label: 'Legal Docs', to: '/legal-docs' },
];

const Footer = () => {
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-800/80 bg-slate-950/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-2 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10">
        <div className="text-center text-xs text-slate-400 lg:text-left">
          © {currentYear} Limbus Intelligence · Confidential
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 lg:justify-end">
          {footerLinks.map(({ label, to }) => {
            const isActive = location.pathname === to;

            return (
              <Link
                key={to}
                to={to}
                className={`text-xs text-slate-400 lg:text-left ${
                  isActive
                    ? 'border-blue-400/70 bg-blue-500/15 text-blue-100'
                    : 'border-slate-700 bg-slate-900/70 text-slate-300 hover:border-slate-500 hover:text-white'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
